import Testimonials from "@/components/sections/testimonials";
import { TESTIMONIAL_DATA } from "@/lib/data";
import { Component } from "@builder.io/sdk";

export const testimonialsConfig: Component = {
  name: "Testimonials (Home)",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Trusted by Many, Loved by All",
    },
    {
      name: "subheading",
      type: "longText",
      defaultValue:
        "We have provided care for more than 13 years in the Bay Area.",
    },
    {
      name: "testimonials",
      type: "list",
      required: true,
      onChange: (options) => {
        if (options.get("testimonials").length > 3) {
          options.set("testimonials", options.get("testimonials").slice(0, 3));
          alert("Maximum testimonials is 3");
        }
      },
      defaultValue: TESTIMONIAL_DATA,
      subFields: [
        {
          friendlyName: "Rate",
          name: "stars",
          step: 1,
          helperText: "Rating between 1 to 5",
          type: "number",
          min: 1,
          max: 5,
        },
        {
          friendlyName: "Name",
          helperText: "Format is <First Name> <Last Initial>, ie. John P.",
          name: "name",
          type: "string",
        },
        {
          friendlyName: "Date",
          helperText: "Format is MMM YYYY, ie. JAN 2025",
          name: "date",
          type: "string",
        },
        {
          friendlyName: "Message",
          name: "text",
          type: "longText",
        },
        {
          friendlyName: "Avatar Url",
          helperText:
            "Url of the uploaded image. (For builder.io, copy image link and paste here)",
          name: "imageURL",
          type: "string",
        },
      ],
    },
    {
      name: "primaryCta",
      type: "object",
      defaultValue: {
        text: "View All Testimonials",
        href: "/testimonial",
        ariaLabel: "View All Testimonials",
      },
      subFields: [
        {
          name: "text",
          type: "string",
        },
        {
          name: "href",
          type: "string",
        },
        {
          name: "ariaLabel",
          type: "string",
        },
      ],
    },
  ],
};

export default Testimonials;
